import React, { useMemo } from 'react';

import { MultiSelect } from '@gogame/components';
import { withFormField } from '@gogame/form';

const CompensationsPicker = withFormField({
  padding: 0,
})(
  ({
    value = [],
    onChange,
    area: { data, error, loading },
    'data-cy': dataCy,
  }) => {
    const selectedValue = useMemo(() => value.map(({ id }) => id), [value]);

    const handleChangeCompensations = (e, valueIds) => {
      onChange(
        e,
        valueIds.map((v) => ({
          ...(value.find(({ id }) => v === id) ||
            data.find(({ id }) => v === id)),
        }))
      );
    };

    return (
      <MultiSelect
        data-cy={dataCy}
        label={'Compensation options'}
        value={selectedValue}
        options={data}
        onChange={handleChangeCompensations}
        loading={loading}
        error={error}
      />
    );
  }
);

export default CompensationsPicker;
